// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-form {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-form ion-card {
  margin: 0;
}
wm-form .wm-form-field-disabled {
  color: var(--wm-color-dark);
  background-color: red;
}
wm-form .wm-form-field-disabled .wm-waypointdetail-icon {
  margin-right: 10px;
}
wm-form .wm-form-field-disabled .wm-waypointdetail-icon.primary {
  color: var(--wm-color-primary);
}
wm-form .wm-form-field-disabled .wm-waypointdetail-icon.secondary {
  color: var(--wm-color-secondary);
}
wm-form .wm-form-field-disabled .wm-waypointdetail-icon.tertiary {
  color: var(--wm-color-tertiary);
}
wm-form .wm-form-field-disabled .wm-waypointdetail-item-title {
  font-weight: var(--wm-font-weight-bold);
  font-size: var(--wm-font-lg);
}
wm-form .wm-form-field-disabled .wm-waypointdetail-item-city {
  display: block;
}
wm-form .wm-form-field-disabled .wm-waypointdetail-item-position {
  display: block;
}
wm-form .wm-form-field {
  padding: 22px 15px 10px 22px;
  overflow: visible;
}
wm-form .wm-form-field.wm-form-item-noicon {
  padding: 0px;
}
wm-form .wm-form-field.compiled {
  --border-color: var(--wm-color-primary);
}
wm-form .wm-form-field.error {
  --border-color: var(--wm-color-red);
}
wm-form .wm-form-field:focus-within {
  --border-color: var(--wm-color-dark);
}
wm-form .wm-form-field .wm-form-field-label {
  font-weight: var(--wm-font-weight-bold);
}
wm-form .wm-form-field .wm-form-field-label .wm-form-field-label-secondary {
  font-weight: var(--wm-font-weight-light);
}
wm-form .wm-form-field .wm-form-field-label .wm-form-field-label-required {
  color: var(--ion-color-danger);
}
wm-form .wm-form-field .wm-form-field-label.wm-form-field-labelphoto {
  height: 30px;
  top: 0px;
  position: absolute;
}
wm-form .wm-form-field .wm-form-field-icon {
  position: absolute;
  left: -28px;
  top: 10px;
  color: var(--wm-color-grey);
}
wm-form .wm-form-field container-element {
  width: 100%;
}
wm-form .wm-form-field container-element .wm-form-field-select {
  width: 100%;
  min-width: 100%;
  margin-left: -20px;
}
wm-form .wm-form-field-error {
  padding: 0px 25px 8px 41px;
  color: var(--ion-color-danger);
  display: inline-block;
}
wm-form .wm-form-field-helper {
  padding: 0px 25px 8px 41px;
  display: inline-block;
}
wm-form .wm-ugc-form-title {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: var(--wm-feature-details-title-font-size);
  font-weight: var(--wm-feature-details-title-font-weight);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
  letter-spacing: 0em;
}
wm-form .wm-ugc-form-title ion-icon {
  font-size: 1.2em;
  display: flex;
  align-items: center;
}
wm-form .wm-ugc-form-title ion-badge {
  display: flex;
  align-items: center;
}
wm-form .wm-ugc-form-item {
  font-size: var(--wm-font-mf);
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
}
wm-form .wm-ugc-form-item .wm-ugc-form-label {
  font-weight: 400;
  font-family: var(--wm-font-family-content);
  flex-shrink: 0;
  min-width: 30%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
wm-form .wm-ugc-form-item .wm-ugc-form-value {
  font-weight: 600;
  font-family: var(--wm-font-family-content);
  flex: 1;
  text-align: right;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
wm-form .wm-form-only-title {
  display: flex;
  flex-direction: column;
  padding: 0px 15px 0px 22px;
}
wm-form .wm-form-only-title ion-title {
  font-size: 18px;
  padding: 8px 0px;
}

ion-alert {
  --min-width: 275px !important;
}
ion-alert .alert-radio-label {
  text-wrap: unset !important;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/form/form.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,wCAAA;AAAF;AACE;EACE,SAAA;AACJ;AAEE;EACE,2BAAA;EACA,qBAAA;AAAJ;AACI;EACE,kBAAA;AACN;AAAM;EACE,8BAAA;AAER;AACM;EACE,gCAAA;AACR;AAEM;EACE,+BAAA;AAAR;AAII;EACE,uCAAA;EACA,4BAAA;AAFN;AAKI;EACE,cAAA;AAHN;AAMI;EACE,cAAA;AAJN;AAQE;EACE,4BAAA;EACA,iBAAA;AANJ;AAOI;EACE,YAAA;AALN;AAQI;EACE,uCAAA;AANN;AASI;EACE,mCAAA;AAPN;AAUI;EACE,oCAAA;AARN;AAaI;EACE,uCAAA;AAXN;AAYM;EACE,wCAAA;AAVR;AAYM;EACE,8BAAA;AAVR;AAYM;EACE,YAAA;EACA,QAAA;EACA,kBAAA;AAVR;AAcI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AAZN;AAcI;EACE,WAAA;AAZN;AAaM;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AAXR;AAeE;EACE,0BAAA;EACA,8BAAA;EACA,qBAAA;AAbJ;AAeE;EACE,0BAAA;EACA,qBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oDAAA;EACA,wDAAA;EACA,4CAAA;EACA,wDAAA;EACA,mBAAA;AAdJ;AAeI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAbN;AAeI;EACE,aAAA;EACA,mBAAA;AAbN;AAgBE;EACE,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,8BAAA;AAdJ;AAeI;EACE,gBAAA;EACA,0CAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAbN;AAeI;EACE,gBAAA;EACA,0CAAA;EACA,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAbN;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;AAdJ;AAeI;EACE,eAAA;EACA,gBAAA;AAbN;;AAkBA;EACE,6BAAA;AAfF;AAgBE;EACE,2BAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,cAAA;AAdJ","sourcesContent":["@import '../theme/mixins.scss';\nwm-form {\n  display: block;\n  margin: var(--wm-feature-details-margin);\n  ion-card {\n    margin: 0;\n  }\n\n  .wm-form-field-disabled {\n    color: var(--wm-color-dark);\n    background-color: red;\n    .wm-waypointdetail-icon {\n      margin-right: 10px;\n      &.primary {\n        color: var(--wm-color-primary);\n      }\n\n      &.secondary {\n        color: var(--wm-color-secondary);\n      }\n\n      &.tertiary {\n        color: var(--wm-color-tertiary);\n      }\n    }\n\n    .wm-waypointdetail-item-title {\n      font-weight: var(--wm-font-weight-bold);\n      font-size: var(--wm-font-lg);\n    }\n\n    .wm-waypointdetail-item-city {\n      display: block;\n    }\n\n    .wm-waypointdetail-item-position {\n      display: block;\n    }\n  }\n\n  .wm-form-field {\n    padding: 22px 15px 10px 22px;\n    overflow: visible;\n    &.wm-form-item-noicon {\n      padding: 0px;\n    }\n\n    &.compiled {\n      --border-color: var(--wm-color-primary);\n    }\n\n    &.error {\n      --border-color: var(--wm-color-red);\n    }\n\n    &:focus-within {\n      --border-color: var(--wm-color-dark);\n    }\n\n    // border: 1px solid var(--ion-color-danger);\n\n    .wm-form-field-label {\n      font-weight: var(--wm-font-weight-bold);\n      .wm-form-field-label-secondary {\n        font-weight: var(--wm-font-weight-light);\n      }\n      .wm-form-field-label-required {\n        color: var(--ion-color-danger);\n      }\n      &.wm-form-field-labelphoto {\n        height: 30px;\n        top: 0px;\n        position: absolute;\n      }\n    }\n\n    .wm-form-field-icon {\n      position: absolute;\n      left: -28px;\n      top: 10px;\n      color: var(--wm-color-grey);\n    }\n    container-element {\n      width: 100%;\n      .wm-form-field-select {\n        width: 100%;\n        min-width: 100%;\n        margin-left: -20px;\n      }\n    }\n  }\n  .wm-form-field-error {\n    padding: 0px 25px 8px 41px;\n    color: var(--ion-color-danger);\n    display: inline-block;\n  }\n  .wm-form-field-helper {\n    padding: 0px 25px 8px 41px;\n    display: inline-block;\n  }\n\n  .wm-ugc-form-title {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    font-size: var(--wm-feature-details-title-font-size);\n    font-weight: var(--wm-feature-details-title-font-weight);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n    letter-spacing: 0em;\n    ion-icon {\n      font-size: 1.2em;\n      display: flex;\n      align-items: center;\n    }\n    ion-badge {\n      display: flex;\n      align-items: center;\n    }\n  }\n  .wm-ugc-form-item {\n    font-size: var(--wm-font-mf);\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    .wm-ugc-form-label {\n      font-weight: 400;\n      font-family: var(--wm-font-family-content);\n      flex-shrink: 0;\n      min-width: 30%;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      white-space: normal;\n    }\n    .wm-ugc-form-value {\n      font-weight: 600;\n      font-family: var(--wm-font-family-content);\n      flex: 1;\n      text-align: right;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      white-space: normal;\n    }\n  }\n  .wm-form-only-title {\n    display: flex;\n    flex-direction: column;\n    padding: 0px 15px 0px 22px;\n    ion-title {\n      font-size: 18px;\n      padding: 8px 0px;\n    }\n  }\n}\n\nion-alert {\n  --min-width: 275px !important;\n  .alert-radio-label {\n    text-wrap: unset !important;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    line-clamp: 3;\n    -webkit-box-orient: vertical;\n    line-height: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
